import { Skeleton } from '@gto/ui/skeleton'

export const FlipOutProgressSkeleton = () => {
  return (
    <div className="flex flex-col gap-2">
      <Skeleton
        variant="text"
        width={120}
      />
      <Skeleton
        height={12}
        variant="rectangular"
        width="100%"
      />
      <div className="flex items-center justify-between">
        <Skeleton
          variant="text"
          width={160}
        />
        <Skeleton
          variant="text"
          width={100}
        />
      </div>
    </div>
  )
}
